export default __webpack_public_path__ + "static/media/reason5.36910f44.svg";